import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeadset } from "@fortawesome/free-solid-svg-icons";
import clsx from "clsx";
import { AuthContext } from "../providers/auth-provider";
import CustomButton from "./customs/custom-button";

const authExemptPaths = ["/auth", "/reset"];

const AgentCodeSetupAlert = () => {
  const auth = useContext(AuthContext);
  const path =
    typeof document !== "undefined" ? document.location.pathname : "";
  const onPublicAuthRoute = authExemptPaths.some(
    (p) => path === p || path.startsWith(`${p}/`),
  );

  if (!auth?.user?.id || onPublicAuthRoute || auth.isLoading) {
    return null;
  }

  const needsSetup = !auth.user.code;

  if (!needsSetup) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="agent-code-alert-title"
      aria-describedby="agent-code-alert-desc"
    >
      <div
        className="absolute inset-0 bg-[var(--shadow-modal-scrim)] backdrop-blur-[6px]"
        aria-hidden
      />
      <div
        className={clsx(
          "relative w-full max-w-[440px] animate-fade-in rounded-2xl border border-edge",
          "bg-surface shadow-overlay shadow-glow-sm",
          "overflow-hidden",
        )}
      >
        <div className="h-1.5 w-full bg-gradient-to-r from-accent via-accent-bright to-accent" />
        <div className="px-8 pb-8 pt-7 text-center">
          <div
            className={clsx(
              "mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl",
              "border border-edge bg-gradient-to-br from-accent/15 to-accent-bright/10 shadow-glow-sm",
            )}
          >
            <FontAwesomeIcon
              icon={faHeadset}
              className="text-2xl text-accent"
              aria-hidden
            />
          </div>
          <h2
            id="agent-code-alert-title"
            className="font-heading-font text-xl font-semibold tracking-tight text-heading-color"
          >
            Account setup required
          </h2>
          <p
            id="agent-code-alert-desc"
            className="mt-3 text-sm leading-relaxed text-text-secondary"
          >
            Your agent code is not set up. Please contact the helpdesk so your
            account can be completed.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:justify-center">
            <CustomButton
              type="button"
              className="!h-11 rounded-xl border border-edge bg-surface-elevated px-5 font-medium text-text-primary shadow-none hover:bg-overlay sm:!w-auto"
              onClick={() => window.location.reload()}
            >
              Refresh
            </CustomButton>
            <CustomButton
              type="button"
              variant="primary"
              className="!h-11 rounded-xl sm:!w-auto"
              onClick={() => auth.HandleUserLogOut()}
            >
              Sign out
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentCodeSetupAlert;
